import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getRelatedContentData } from "../redux/slices/searchActions";
import { DateFormate, getBadge } from "../helpers/CommonHelpers";
import he from 'he';

export default function RelatedContent() {
  const dispatch = useDispatch();
  const [relatedProducts, setRelatedProducts] = useState(undefined);
  const [relatedReference, setRelatedReference] = useState(undefined);
  const [relatedContent, setRelatedContent] = useState(undefined);

  const fetchRelatedContentData = async () => {
    var url = window.location.href;

    var response = await dispatch(
      getRelatedContentData({
        Link: url,
      })
    );
    setRelatedProducts(response.payload.data.relatedProducts);
    setRelatedReference(response.payload.data.relatedReferences);
    setRelatedContent(response.payload.data.relatedContent);
  };

  useEffect(() => {
    fetchRelatedContentData();
  }, []);

  return (
    <div className="related-content-section">
      <div className="public-container">
        <div className="related-content-row">
          <div className="two-column-flex-grow">
            <div className="related-products-wrap">
              <div className="d-flex align-items-center justify-content-between">
                <span className="related-content-heading">
                  Related Products
                </span>
                {/* <div className="text-start d-block d-md-none">
                  <a class="history-view-all" href="/atlas/search?ct=product">
                    View More
                  </a>
                </div> */}
              </div>
              <div className="products-list-wrap">
              {!relatedProducts || relatedProducts.length === 0 ? (
                  <div className="">
                    <div className="placeholder-glow">
                      <span className="placeholder col-10 products-list"></span>
                      <span className="placeholder col-10 products-list"></span>
                      <span className="placeholder col-10 products-list"></span>
                      <span className="placeholder col-10 products-list"></span>
                      <span className="placeholder col-10 products-list"></span>
                      <span className="placeholder col-10 products-list"></span>
                      <span className="placeholder col-10 products-list"></span>
                    </div>
                  </div>
                ) : (
                  relatedProducts.map((product, index) => {
                    return (
                      <a href={`${product?.link ?? '/'}`} className="products-list" key={index}>
                        {product.title}
                      </a>
                    );
                  })
                )}

              </div>
              
              {/* <div className="text-start d-none d-md-block">
                <a class="history-view-all" href="/atlas/search?ct=product">
                  View More
                </a>
              </div> */}
            </div>
            <div className="related-reference-wrap">
              <div className="d-flex align-items-center justify-content-between">
                <span className="related-content-heading">
                  Related Reference
                </span>
                {/* <div className="text-start d-block d-md-none">
                  <a class="history-view-all" href="/glossary">
                    View More
                  </a>
                </div> */}
              </div>
              {(!relatedReference || relatedReference.length === 0) ? (
                  <div className="">
                    <div className="placeholder-glow">
                      <div className="report-content">
                        <div className="resultsManagmentCardContent">
                          <span className="placeholder col-8 products-list glossary-title"></span>
                          <span className="card-bottom-text">
                            <span className="placeholder col-12"></span>
                          </span>
                        </div>
                      </div>
                      <div className="report-content">
                        <div className="resultsManagmentCardContent">
                          <span className="placeholder col-8 products-list glossary-title"></span>
                          <span className="card-bottom-text">
                            <span className="placeholder col-12"></span>
                          </span>
                        </div>
                      </div>
                      <div className="report-content">
                        <div className="resultsManagmentCardContent">
                          <span className="placeholder col-8 products-list glossary-title"></span>
                          <span className="card-bottom-text">
                            <span className="placeholder col-12"></span>
                          </span>
                        </div>
                      </div>
                      <div className="report-content">
                        <div className="resultsManagmentCardContent">
                          <span className="placeholder col-8 products-list glossary-title"></span>
                          <span className="card-bottom-text">
                            <span className="placeholder col-12"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  relatedReference.map((reference, index) => {
                    return (
                      <div className="report-content" key={index}>
                        <div className="resultsManagmentCardContent">
                          <a href={`${reference?.link ?? '/'}`} className="glossary-title stretched-link">
                            {he.decode(reference.title)}
                          </a>
                          <span className="card-bottom-text">
                            {reference.shortDescription.length > 150 && reference.shortDescription && (
                              <>
                                {`${reference.shortDescription.substring(0, 150)}...`}
                                <b>more</b>
                              </>
                            )}
                            {reference.shortDescription.length <= 150 && reference.shortDescription && (
                              he.decode(reference.shortDescription)
                            )}
                          </span>
                        </div>
                      </div>
                    );
                  })
                )}

              {/* <div className="text-end d-none d-md-block">
                <a class="history-view-all" href="/glossary">
                  View More
                </a>
              </div> */}
            </div>
          </div>
          <div className="related-Content-wrap">
            <div className="d-flex align-items-center justify-content-between">
              <span className="related-content-heading">Related Content</span>
              {/* <div className="text-start d-block d-md-none">
                <a class="history-view-all" href="/broken">
                  View More
                </a>
              </div> */}
            </div>
            {(!relatedContent || relatedContent.length === 0) ? (
              <div className="">
                <div className="placeholder-glow">
                  <div className="report-content">
                    <div className="resultsManagmentCardContent">
                      <span className="placeholder col-2 me-3"></span>
                      <span className="placeholder col-3"></span>
                      <span className="placeholder col-12 mt-3"></span>
                    </div>
                  </div>
                  <div className="report-content">
                    <div className="resultsManagmentCardContent">
                      <span className="placeholder col-2 me-3"></span>
                      <span className="placeholder col-3"></span>
                      <span className="placeholder col-12 mt-3"></span>
                    </div>
                  </div>
                  <div className="report-content">
                    <div className="resultsManagmentCardContent">
                      <span className="placeholder col-2 me-3"></span>
                      <span className="placeholder col-3"></span>
                      <span className="placeholder col-12 mt-3"></span>
                    </div>
                  </div>
                  <div className="report-content">
                    <div className="resultsManagmentCardContent">
                      <span className="placeholder col-2 me-3"></span>
                      <span className="placeholder col-3"></span>
                      <span className="placeholder col-12 mt-3"></span>
                    </div>
                  </div>
                  <div className="report-content">
                    <div className="resultsManagmentCardContent">
                      <span className="placeholder col-2 me-3"></span>
                      <span className="placeholder col-3"></span>
                      <span className="placeholder col-12 mt-3"></span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              relatedContent.map((content, index) => {
                return (
                  <div className="report-content" key={index}>
                    <div className="resultsManagmentCardContent">
                      {getBadge(content.contentType, true)}
                      <span className="reportInfo">
                        {content.lastSignificantUpdate 
                          ? `Updated: ${DateFormate(content.lastSignificantUpdate, "MMMM d, yyyy")}` 
                          : content.publishDate 
                          ? DateFormate(content.publishDate, "MMMM d, yyyy") 
                          : ""}
                      </span>
                      <a href={`${content?.link ?? '/'}`} className="reportTitle stretched-link">
                        {he.decode(content.title)}
                      </a>
                    </div>
                  </div>
                );
              })
            )}
            {/* <div className="text-end d-none d-md-block">
              <a class="history-view-all" href="/broken">
                View More
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
